export default __webpack_public_path__ + "static/product-description_es-0a3e17fd9b4e90955572260538652b22.pdf";